import * as R from "ramda";
import { validateObject, validateField } from "util/validation";
import { notBlank } from "../util/ext";
import { curry } from "ramda";

const userConstraints = {
  username: {
    presence: {
      allowEmpty: false,
      message: "^Username must not be blank",
    },
  },

  emailAddress: {
    presence: {
      allowEmpty: false,
      message: "^Email Address must not be blank",
    },
    email: {
      message: "^Invalid email address",
    },
  },
};

const emailConstraints = {
  emailAddress: {
    presence: {
      allowEmpty: false,
      message: "^Email Address must not be blank",
    },
    email: {
      message: "^Invalid email address",
    },
  },
};

const newUserConstraints = {
  username: {
    presence: {
      allowEmpty: false,
      message: "^Username must not be blank",
    },
  },

  password: {
    presence: {
      allowEmpty: false,
      message: "^Password must not be blank",
    },
  },

  confirmPassword: {
    presence: {
      allowEmpty: false,
      message: "^Confirm Password must not be blank",
    },
  },

  organizationId: {
    presence: {
      allowEmpty: false,
      message: "^An Organization must be selected",
    },
  },

  emailAddress: {
    presence: {
      allowEmpty: false,
      message: "^Email Address must not be blank",
    },
    email: {
      message: "^Invalid email address",
    },
  },
};

export const validateUserField = (field, value, errors = {}) =>
  validateField(userConstraints, field, value, errors);

export const validateUser = R.partial(validateObject, [userConstraints]);

export const validateNewUser = R.partial(validateObject, [newUserConstraints]);

export const validateNewUserField = (field, value, errors = {}) =>
  validateField(newUserConstraints, field, value, errors);

export const validateEmailField = (field, value, errors = {}) =>
  validateField(emailConstraints, field, value, errors);

export const validateEmail = R.partial(validateObject, [emailConstraints]);

export const hasError = curry((errors, field) => notBlank(errors[field]));

export const firstError = curry((errors, field) =>
  errors[field] ? errors[field][0] : "",
);
